<api-call-gate [apiCall]="lastDataSourceRefreshInformations">
  <ng-template #lastSuccessfulData>
    <div class="states">
      <!-- tube ONLY -->
      <div class="item" *ngIf="systemDetails.modalityId === 2">
        <app-lastDataSourceRefreshTubeCoil
          [systemDetails]="systemDetails"
          [endpoint]="tubeService.dataSourceUpdateStatus"
          title="label.lastDataSourceRefresh.tubeHeader"
        >
        </app-lastDataSourceRefreshTubeCoil>
      </div>

      <div class="item" *ngIf="isXPSystem">
        <app-lastDataSourceRefreshTubeCoil
          [systemDetails]="systemDetails"
          [endpoint]="tubeService.dataSourceUpdateStatus"
          title="label.lastDataSourceRefresh.tubeHeader"
        >
        </app-lastDataSourceRefreshTubeCoil>
      </div>

      <!-- coil ONLY -->
      <div class="item" *ngIf="systemDetails.modalityId === 1">
        <!-- we are not sure why tube service is used here -->
        <!-- assumption here is that also coil refresh status is servied from tube service (why????) -->
        <app-lastDataSourceRefreshTubeCoil
          [systemDetails]="systemDetails"
          [endpoint]="coilService.getCoilStatus"
          title="label.lastDataSourceRefresh.coilHeader"
        >
        </app-lastDataSourceRefreshTubeCoil>
      </div>

      <!-- MRTicker -->
      <div
        class="item"
        *ngIf="
          systemDetails.modalityId === 1 && (data$('MRTicker') | async) as data
        "
      >
        <app-lastDataSourceRefreshStatus
          [lastDataSourceRefreshState]="data"
          [lastUpdateHeader]="'label.lastUpdateHeader' | translate"
          [lastPatternHeader]="'label.lastUpdatePatternHeader' | translate"
          [labelStatusHeader]="
            'label.mrTickerLastDataSourceRefresh.statusHeader' | translate
          "
        ></app-lastDataSourceRefreshStatus>
      </div>

      <!-- CTPattern -->
      <div
        class="item"
        *ngIf="
          systemDetails.modalityId === 2 && (data$('CTPattern') | async) as data
        "
      >
        <app-lastDataSourceRefreshStatus
          [lastDataSourceRefreshState]="data"
          [lastUpdateHeader]="'label.lastUpdateHeader' | translate"
          [lastPatternHeader]="'label.lastUpdatePatternHeader' | translate"
          [labelStatusHeader]="
            'label.ctPatternLastDataSourceRefresh.statusHeader' | translate
          "
        ></app-lastDataSourceRefreshStatus>
      </div>

      <!-- Device Monitoring -->
      <div
        class="item"
        *ngIf="
          systemDetails.modalityId !== 5 &&
          (data$('DeviceMonitoring') | async) as data
        "
      >
        <app-lastDataSourceRefreshStatus
          [lastDataSourceRefreshState]="data"
          [lastUpdateHeader]="'label.lastUpdateHeader' | translate"
          [lastPatternHeader]="'label.lastUpdatePatternHeader' | translate"
          [labelStatusHeader]="
            'label.srsDeviceMonitoringLastDataSourceRefresh.statusHeader'
              | translate
          "
        ></app-lastDataSourceRefreshStatus>
      </div>

      <!-- PSM Pattern -->
      <div
        class="item"
        *ngIf="
          systemDetails.modalityId === 5 &&
          (data$('PSM Pattern') | async) as data
        "
      >
        <app-lastDataSourceRefreshStatus
          [lastDataSourceRefreshState]="data"
          [lastUpdateHeader]="'label.lastUpdatePSMHeader' | translate"
          [lastPatternHeader]="'label.lastUpdatePatternHeader' | translate"
          [labelStatusHeader]="
            'label.psmPatternLastDataSourceRefresh.statusHeader' | translate
          "
        ></app-lastDataSourceRefreshStatus>
      </div>

      <!-- PSM Pattern -->
      <div
        class="item pxr"
        *ngIf="systemDetails.modalityId === 2 && (data$('PXR') | async) as data"
      >
        <app-lastDataSourceRefreshStatus
          [hideLastUpdate]="true"
          [lastDataSourceRefreshState]="data"
          [lastUpdateHeader]="'label.lastUpdatePSMHeader' | translate"
          [lastPatternHeader]="'label.lastUpdatePatternHeader' | translate"
          [labelStatusHeader]="'label.lastUpdatePXRHeader' | translate"
        ></app-lastDataSourceRefreshStatus>
      </div>
    </div>
  </ng-template>
</api-call-gate>
<ng-container
  *ngIf="
    (!configService.getPortalWebAppConfiguration().disableSRSTaskButtonMR &&
      systemDetails?.modalityId === 1) ||
    (!configService.getPortalWebAppConfiguration().disableSRSTaskButtonCT &&
      systemDetails?.modalityId === 2)
  "
>
  <!-- currently only enabled for MR systems -->
  <sh-divider spacing="m" style="width: 100%"></sh-divider>
  <app-run-task-button
    [systemSerialNumber]="systemDetails.systemSerialNumber"
    [systemMaterialNumber]="systemDetails.systemMaterialNumber"
    [systemSoftwareVersion]="systemDetails.systemSoftwareVersion"
    [systmModalityString]="systemDetails.modalityId === 1 ? 'MR' : 'CT'"
    [labels]="{
      button: 'Request new data',
      neverExecuted: 'Not used within the last 24 hours.',
      lastExecutedLabel:
        'Data collection takes time. Last collection of platform messages:',
    }"
    [taskAPI]="{
      trigger: systemOverviewService.triggerSrsDataCollection,
      getStatus: systemOverviewService.getSrsDataCollectionStatus,
    }"
  ></app-run-task-button>
</ng-container>
